import { useEffect } from 'react';

import { FlightRoomState, useChannelStore, useFlightRoomStore, useMessageStore } from '../../stores';

const handleFlightRoomChanges = (state: FlightRoomState, prevState: FlightRoomState) => {
  const prevFlightRooms = prevState?.flightRooms;
  const currentFlightRooms = state.flightRooms;

  if (!prevFlightRooms || currentFlightRooms === prevFlightRooms) {
    return;
  }

  const removedRoomUuids = Array.from(prevFlightRooms.keys()).filter(id => !currentFlightRooms.has(id));
  if (removedRoomUuids.length === 0) {
    return;
  }

  const channelStore = useChannelStore.getState();
  const messageStore = useMessageStore.getState();

  const channelIdsToRemove = removedRoomUuids.flatMap(roomUuid => {
    const roomChannels = channelStore.channelsMap.get(roomUuid);
    return roomChannels ? [roomChannels.mainChannel.id, ...roomChannels.customChannels.map(c => c.id)] : [];
  });

  if (channelIdsToRemove.length > 0) {
    messageStore.removeMessagesForChannels(channelIdsToRemove);
  }

  channelStore.removeChannelsForRooms(removedRoomUuids);
};

export const useStoreOrchestration = () => {
  useEffect(() => {
    const unsubscribe = useFlightRoomStore.subscribe(handleFlightRoomChanges);

    return () => {
      unsubscribe();
    };
  }, []);
};
